// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610062221/js/" + chunkId + "." + {"44":"676457be","225":"7c39d745","481":"97892cb5","486":"fe1ee15c","770":"ddc9bb4e"}[chunkId] + ".0.5644424989096689.chunk.js";
};